import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import QuestionPanel from './questionPanel';

const cool_warm_contrast_match = [
  [2, 2, 0],
  [1, 1, 3],
];

function contrastGroup(hairIndex, skinIndex) {
  var hairGroup = Math.floor(hairIndex / 2) + 1;
  var skinGroup = Math.floor(skinIndex / 2) + 1;
  var diff = Math.abs(hairGroup - skinGroup);
  if (diff === 1 || diff === 0 || diff === 2) {
    return diff;
  } else {
    return -1;
  }
}
function getSkinGroup(index) {
  switch (index) {
    case 4:
    case 2:
    case 0:
      // 0 is for warm
      return 0;
    case 5:
    case 3:
    case 1:
      // 1 is for cool
      return 1;
    default:
      return -1;
  }
}

const Quiz = ({ history }) => {
  const onFinish = answers => {
    const [pressedHairIndex, pressedSkinIndex] = answers;
    if (pressedSkinIndex === -1 || pressedHairIndex === -1) {
      return false;
    }
    const skin_group = getSkinGroup(pressedSkinIndex);
    const contrast_group = contrastGroup(pressedHairIndex, pressedSkinIndex);
    let theRecommendation = 0;
    theRecommendation = cool_warm_contrast_match[skin_group][contrast_group];
    history.push(`/vm/${theRecommendation}`);
  };

  return (
    <React.Fragment>
      <div className="quiz-component">
        <div className="component-wrapper">
          <h2 className="text-center">
            <FormattedMessage
              id="dba.about_urself"
              defaultMessage="Tell us more about yourself"
            />
          </h2>
          <QuestionPanel onFinish={onFinish} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Quiz);
